import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {IntermediatePriceAdjustment} from "./pricing-adjustments.component";
import {EndpointsProvider} from "../../../../umbrella-common/endpoints/endpoint-provider.service";
import {CLIENT_COUNTRY_CONFIGS} from "../../../../configuration/configs/client-country-configs";
import {orderSelector} from "../../../../store/state/state.selectors";
import {filter, first, mergeMap} from "rxjs/operators";
import {Store} from "@ngrx/store";
import {AppState} from "../../../../store/state/app.state";

@Injectable()
export class IntermediatePriceAdjustmentsFetchService {

	constructor(private endpoints: EndpointsProvider, private store: Store<AppState>) {
	}

	fetch(): Observable<IntermediatePriceAdjustment[]> {
		const config = CLIENT_COUNTRY_CONFIGS;

		return this.store.select(orderSelector).pipe(
			filter(order => order.clientCountry != null),
			first(),
			mergeMap(order => {
				const country = order.clientCountry;
				const accBody = config[country].accreditationBody;
				return this.endpoints.review.getIntermediatePriceAdjustments(accBody);
			})
		);
	}
}
